export const getDeliveryOptionText = (optionCode: string): string => {
  switch (optionCode) {
    case 'EXPRESS_24':
      return 'Express Delivery';
    case 'SATURDAY':
      return 'Saturday Guaranteed';
    case 'FREE':
    case 'STANDARD':
    default:
      return 'Standard Delivery';
  }
};
